import URI from 'urijs';
import logger from '@/utils/logger';

const { isArray } = Array;

export { default as cloneDeep } from 'lodash.clonedeep';
export { default as range } from 'lodash.range';
export { default as deepMerge } from 'deepmerge';
export { isArray };

/**
 * @returns {string | null}
 */
export const getUserId = (isLogging = true) => {
  const userId = new URI().query(true).user;
  if (!userId) {
    if (isLogging) {
      logger.error('User id not found!');
    }
    return null;
  }
  return userId;
};

/**
 * @returns {string | null}
 */
export const getAppUser = (isLogging = true) => {
  const appUser = new URI().query(true).appuser;
  if (!appUser) {
    if (isLogging) {
      logger.error('app user not found!');
    }
    return null;
  }
  return appUser;
};

/**
 * Генератор случайных чисел
 *
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export const randomInteger = (min = 0, max = 1) => {
  let result = (max - min) + 1;
  result *= Math.random();
  result += min - 0.5;
  return parseInt(Math.round(result), 10);
};

/**
 * @param {Array} array
 * @returns {*}
 */
export const randomArrayElement = (array = []) => array[randomInteger(0, array.length - 1)];

/**
 * Вычисление процента от числа
 *
 * @param {number} percent
 * @param {number} value
 * @returns {number}
 */
export const percentOfInteger = (percent, value) => (value * percent) / 100;

/**
 * Подстановка ведущих нулей
 *
 * @param {number | string} value
 * @param {number} length
 * @returns {string}
 */
export const leadingZero = (value, length = 2) => {
  let result = String(value);

  while (result.length < length) {
    result = `0${value}`;
  }

  return result;
};

/**
 * Получить случайный элемент массива
 *
 * @param {Array} array
 * @returns *
 */
export const getRandomInArray = (array) => {
  if (!isArray(array)) {
    logger.error('Argument "array" is invalid!');
    return null;
  }
  return array[Math.floor(Math.random() * array.length)];
};

/**
 * Генератор асинхронной задержки
 *
 * @param {number} ms
 * @returns {Promise<any>}
 */
export const asyncDelay = (ms) => (
  new Promise((resolve) => setTimeout(resolve, ms))
);

/**
 * @param {string} value
 * @returns {string}
 */
export const formatTime = (value) => {
  if (!value) {
    return '';
  }
  const [, time] = String(value).match(/(\d{1,2}:\d{2}).*/);
  return leadingZero(time, 5);
};

/**
 * Generate random string
 * @param {string} prefix
 */
export const generateId = (prefix = '') => (
  `${prefix}${Math.random()
    .toString(36)
    .substring(2, 10)}`
);
